module.exports = __webpack_public_path__ + "img/9791165181222.12076199.jpg";